import { render } from "./LayoutMain.vue?vue&type=template&id=abb1efc8&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=ts"
export * from "./LayoutMain.vue?vue&type=script&lang=ts"

import "./LayoutMain.vue?vue&type=style&index=0&id=abb1efc8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-abb1efc8"

export default script